class BobbleryCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    if (!this.track || this.slides.length === 0) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
    this.interval = parseInt(this.dataset.interval, 10) || 4000;
    this.timer = null;
    this.paused = false;
    this.activeIndex = 0;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCards(1));

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.scrollToCard(i));
    });

    this.onScroll = this.throttle(() => this.updateActive(), 100);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    // Pause on hover / touch
    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) =>
      this.addEventListener(evt, () => (this.paused = true), { passive: true })
    );
    ['mouseleave', 'focusout', 'touchend'].forEach((evt) =>
      this.addEventListener(evt, () => (this.paused = false), { passive: true })
    );

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stopAutoplay();
      else this.startAutoplay();
    });

    this.updateActive();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  cardStep() {
    if (this.slides.length < 2) return this.slides[0].offsetWidth;
    return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
  }

  scrollByCards(dir) {
    this.track.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
  }

  scrollToCard(i) {
    const slide = this.slides[i];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  updateActive() {
    const center = this.track.scrollLeft + this.track.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    this.slides.forEach((slide, i) => {
      const slideCenter = slide.offsetLeft - this.track.offsetLeft + slide.offsetWidth / 2;
      const dist = Math.abs(slideCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    this.activeIndex = best;
    this.dots.forEach((dot, i) => {
      const isActive = i === best;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.timer) return;
    this.timer = setInterval(() => {
      if (this.paused) return;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      if (atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollByCards(1);
      }
    }, this.interval);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  throttle(fn, wait) {
    let last = 0;
    let queued = null;
    return () => {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn();
      } else {
        clearTimeout(queued);
        queued = setTimeout(() => {
          last = Date.now();
          fn();
        }, wait - (now - last));
      }
    };
  }
}

if (!customElements.get('bobblery-carousel')) {
  customElements.define('bobblery-carousel', BobbleryCarousel);
}
